import { A4uHeal as IconComponent } from '@adobe/react-spectrum-workflow/dist/Heal.js';
import { Icon } from '@react-spectrum/icon';
import React from 'react';
export default function Heal(props) {
  return /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement(IconComponent, null));
}